<div class="image-select">
  <div class="image-select-label" *ngIf="showHeader">
    <label>{{ question.label }}</label>

    <app-help-popup *ngIf="question.helpKey" [key]="question.helpKey"> </app-help-popup>
  </div>

  <div class="input-group image-selected" [class.has-error]="question.error" id="imageSelect-{{ question.key }}">
    <div *ngFor="let opt of question.options.options ?? question.options" class="option">
      <a
        (click)="select(opt)"
        [class.selected]="selectedOption?.Label === opt.Label"
        href="javascript:void(0)"
        (keydown.space)="select(opt)"
        (keydown.enter)="select(opt)">
        <img [src]="showImage(opt, false)" [class.offscreen]="value === opt.Value" />
        <img [src]="showImage(opt, true)" [class.offscreen]="value !== opt.Value" />

        <label [innerHtml]="opt.Label"></label>
      </a>

      <ng-container *ngIf="opt.tipKey">
        <float-ui-content #tipDiv>
          <div class="tip">
            <app-site-content [key]="opt.tipKey"></app-site-content>
            <div id="arrow" data-popper-arrow></div>
          </div>
        </float-ui-content>

        <ion-icon
          class="tip-icon"
          name="help-circle"
          [floatUi]="tipDiv"
          [showTrigger]="'click'"
          hideOnClickOutside
          [hideOnScroll]="true"
          appendTo="body">
        </ion-icon>
      </ng-container>
    </div>

    <input class="offscreen" [(ngModel)]="value" required [name]="question.key" #val="ngModel" tabindex="-1" (cdkAutofill)="autoFilled()" />
  </div>
</div>
